/*
 * @Author: Tarzan
 * @Date: 2021-05-26 11:15:43
 * @LastEditTime: 2022-01-06 10:27:32
 * @LastEditors: Please set LastEditors
 * @Description:
 * @FilePath: \mall_pc\src\store\getters.js
 */
import { systemType } from '@/common/Enum/index'

const getters = {
	sidebar          : state => state.app.sidebar,
	size             : state => state.app.size,
	device           : state => state.app.device,
	visitedViews     : state => state.tagsView.visitedViews,
	cachedViews      : state => state.tagsView.cachedViews,
	token            : state => state.user.token,
	userType         : state => state.user.userType,
	roleCode         : state => state.user.roleCode,
	avatar           : state => state.user.avatar,
	name             : state => state.user.name,
	lable            : state => state.user.lable,
	introduction     : state => state.user.introduction,
	roles            : state => state.user.roles,
	permission_routes: state => state.permission.routes,
	addRoutes        : state => state.permission.addRoutes,
	menuTxt          : state => state.permission.menuTxt,
	errorLogs        : state => state.errorLog.logs,
	franchiseeNo     : state => state.user.franchiseeNo,
	franchiseeName   : state => state.user.franchiseeName,
	erpCusNo         : state => state.user.erpCusNo,
	storeNo          : state => state.user.storeNo,
	storeName        : state => state.user.storeName,
	parentUserId     : state => state.user.parentUserId,
	userId           : state => state.user.userId,
	refDisNo         : state => state.user.refDisNo,
	brandIds         : state => state.user.brandIds,
	roleGroupCode    : state => state.user.roleGroupCode,
	keyValues        : state => state.user.keyValues,
	code             : state => state.user.code,
	vipCode			 : state => state.user.code,
	storeStatus      : state => state.user.storeStatus,
	franchiseeStatus : state => state.user.franchiseeStatus,
	isMainAccount	   : state => state.user.userType == 0,
	role: state => {
		const userinfo = state.user
		if (userinfo.franchiseeStatus == 2 || userinfo.storeStatus == 2) {
			return 2 // 加盟商/认证会员
		} else if (!userinfo.token) {
			return 0 // 未登录 登录看价
		}
		return 1 // 未认证 认证看价
	},
	vipTips: state => state.app.vipTips,
    defaultImg: state => { // 默认商品图
        return state.systemType === systemType.e2vList.YOKELLY_CS ?  require('@/assets/image/default_yokelly.jpg') : require('@/assets/image/default_avatar.jpg')
    },
    brandName: state => { // 系统品牌名称
        return systemType.v2lList[state.systemType]
    }
}
export default getters
